<table id="Dt1"
  datatable
  [dtOptions]="dtOptions"
  [dtTrigger]="dtTrigger"
  class="tables table-bordered table-striped table-sm w-100 mt-2">
</table>
